import React, { FC, StrictMode } from 'react';
import { DefaultTheme, GlobalStyle } from 'UI-Dash-Commons-UI';

import { env } from 'config';
import useFrame from 'hooks/useFrame';
import AppRoutes from './AppRoutes';
import Breadcrumbs from './Breadcrumbs';
import Navigation from './Navigation';
import 'utils/sentry';

const App: FC<{}> = () => {
    useFrame();
    const app = (
        <DefaultTheme>
            <GlobalStyle />
            <Breadcrumbs />
            {env === 'local' && <Navigation />}
            <AppRoutes />
        </DefaultTheme>
    );

    return env === 'local' ? <StrictMode>{app}</StrictMode> : app;
}
 
export default App;
 